/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type { MarkAllNotificationsAsReadMutationResponse } from '../types/MarkAllNotificationsAsRead'

function getMarkAllNotificationsAsReadUrl() {
  const res = {
    method: 'POST',
    url: `/api/v1/notifications/mark-all-as-read/` as const,
  }
  return res
}

/**
 * @summary Mark all of the current user's unread notifications as read
 * {@link /api/v1/notifications/mark-all-as-read/}
 */
export async function markAllNotificationsAsRead(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    MarkAllNotificationsAsReadMutationResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'POST',
    url: getMarkAllNotificationsAsReadUrl().url.toString(),
    ...requestConfig,
  })
  return res.data
}
